var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "#DAC599",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5.5a7 7 0 1 0 .001 14.001A7 7 0 0 0 7.5.5M8 10.875a.125.125 0 0 1-.125.125h-.75A.125.125 0 0 1 7 10.875v-4.25c0-.069.056-.125.125-.125h.75c.069 0 .125.056.125.125zM7.5 5.5a.75.75 0 0 1 0-1.5.75.75 0 0 1 0 1.5"
  })));
};
export default SvgInfoCircle;